import { render, staticRenderFns } from "./ApplicationManagement.vue?vue&type=template&id=3248af82&scoped=true"
import script from "./ApplicationManagement.vue?vue&type=script&lang=js"
export * from "./ApplicationManagement.vue?vue&type=script&lang=js"
import style0 from "./ApplicationManagement.vue?vue&type=style&index=0&id=3248af82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3248af82",
  null
  
)

export default component.exports